module.exports = __webpack_public_path__ + "img/av.d28f760f.png";